<template>
  <div class="keepRecordPage" v-if="!showLoad">
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      class="ul_List"
      v-if="dataList.length != 0"
    >
      <van-list
        :loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul class="list_ul">
          <li class="list_li" v-for="(itemList, index) in dateArr" :key="index">
            <div :class="['circleBox']">
              <span class="ggCircle circleFirst"></span>
              <span
                class="circleLast ggCircle"
                v-if="dateArr.length - 1 > index"
              ></span>
            </div>
            <div
              class="itemLi dis_flex"
              v-for="(item, itemIndex) in itemList"
              :key="item.id"
            >
              <span class="ggCircle childCircle" v-if="itemIndex > 0"></span>
              <div class="list_left">
                <span class="bigText" v-if="itemIndex < 1">{{
                  item.createTime.substring(2, 10)
                }}</span>
              </div>
              <div class="list_right">
                <div class="titleWrap clearfix">
                  <img
                    :src="`${
                      item.avatar
                        ? item.avatar
                        : baseUrl +
                          'userDefault.png?x-oss-process=image/resize,m_fixed,h_25,w_25'
                    }`"
                    alt
                    class="fl"
                  />
                  <span class="title fl">{{ item.realName }}</span>
                </div>
                <div>
                  <div class="textWrap" @click="getJumpUrl(item)">
                    <span class="text">{{ item.content }}</span>
                  </div>
                  <div class="imgWrap dis_flex" v-if="item.imgs.length != 4">
                    <div
                      class="img"
                      v-for="(itemImg, imgIndex) in item.imgs"
                      :key="'dfff' + itemImg + item.id + imgIndex"
                      @click="getJumpUrl(item)"
                    >
                      <van-image
                        fit="cover"
                        :src="
                          itemImg +
                          '?x-oss-process=image/resize,m_fixed,h_75,w_75'
                        "
                      />
                    </div>
                  </div>
                  <div class="imgWrap" v-else>
                    <div class="dis_flex">
                      <template v-for="(itemImg, imgIndex) in item.imgs">
                        <div
                          class="img"
                          :key="itemImg + item.id + imgIndex"
                          v-if="imgIndex == 0 || imgIndex == 1"
                          @click="getJumpUrl(item)"
                        >
                          <van-image
                            fit="cover"
                            :src="
                              itemImg +
                              '?x-oss-process=image/resize,m_fixed,h_75,w_75'
                            "
                          />
                        </div>
                      </template>
                    </div>
                    <div class="dis_flex">
                      <template v-for="(itemImg, imgIndex) in item.imgs">
                        <div
                          class="img"
                          :key="itemImg + item.id + imgIndex"
                          v-if="imgIndex == 2 || imgIndex == 3"
                          @click="getJumpUrl(item)"
                        >
                          <van-image
                            fit="cover"
                            :src="
                              itemImg +
                              '?x-oss-process=image/resize,m_fixed,h_75,w_75'
                            "
                          />
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="peopleAction">
                  <span class="smallText">{{
                    item.createTime.substring(10)
                  }}</span>
                  <div class="actionItem">
                    <div class="criticLike" @click="handleClick(item)">
                      <span class="criticLikeIcon red" v-if="item.isLike">
                        <van-icon name="good-job" />
                        <span class="criticCount" v-if="item.likeNum !== '0'">{{
                          item.likeNum
                        }}</span>
                      </span>
                      <span class="criticLikeIcon" v-else>
                        <van-icon name="good-job-o" />
                        <span class="criticCount" v-if="item.likeNum !== '0'">{{
                          item.likeNum
                        }}</span>
                      </span>
                    </div>
                    <div class="commentNum" @click="getJumpUrl(item)">
                      <span class="commentIcon">
                        <van-icon name="comment-o" />
                        <span class="commentCount">{{
                          item.commentNum ? item.commentNum : ""
                        }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>

    <div class="nonePage" v-if="dataList.length == '0' && refreshing">
      <img :src="baseUrl + 'empty.png'" alt />
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState, mapMutations } from "vuex";
import { Showswiper, getCurData } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { LocationHref } from "@/api/config";
export default {
  name: "keepRecord",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      searchVal: "", //搜索
      dateArr: [],
      dataList: [], //数据集合
      sourceData: [], //
      total: 0,
      pageNum: 0, //当前页码
      pageSize: 5, //每页多少条
      refreshing: false,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      addJsPickerShow: false,
      baseData: {
        content: "",
        imgs: [],
        title: "",
      },
      btnLoading: false,
      newDate: "",
      newDateYears: "",
      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    window.setFile = this.setFiles; //app返回附件回调
    window.initPage = this.initPage;
    window.onRefresh = this.onRefresh;
    this.newDate = new Date(getCurData()).getTime();
    this.newDateYears = getCurData().substring(0, 4);
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      //

      let _this = this;
      let data = {
        content: _this.searchVal,
      };
      if (_this.pageNum != 0 && this.pageNum * 5 >= parseInt(_this.total)) {
        return;
      }
      _this.pageNum += 1;
      _this.$api.userCenter.user
        .noteList(_this.pageNum, _this.pageSize, data)
        .then((res) => {
          if (res.code == "1") {
            this.setShowLoad(false);
            _this.total = parseInt(res.data.total);
            if (_this.total > 0) {
              _this.refreshing = false;
            } else {
              _this.refreshing = true;
            }
            _this.sourceData = res.data.list;
            _this.sourceData.forEach((item) => {
              item.createHours = item.createTime.substring(2, 10);
            });
            _this.$nextTick(() => {
              _this.viewLists();
            });

            // 加载状态结束
            _this.loading = false;

            if (_this.pageNum * 5 >= _this.total) {
              _this.finished = true;
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    viewLists() {
      let _this = this;
      _this.dataList = _this.dataList.concat(_this.sourceData);
      let sourceArr = _this.dataList;
      _this.dateArr = _this.sortArr(sourceArr, "createHours");

      if (_this.clientType == "android") {
        console.log("调用安卓!!!!")
        window.android.getInfo(128);
      }
    },
    sortArr(arr, str) {
      var _arr = [],
        _t = [],
        // 临时的变量
        _tmp;

      // 按照特定的参数将数组排序将具有相同值得排在一起
      arr = arr.sort(function (a, b) {
        var s = a[str],
          t = b[str];

        return s < t ? -1 : 1;
      });

      if (arr.length) {
        _tmp = arr[0][str];
      }
      // console.log( arr );
      // 将相同类别的对象添加到统一个数组
      for (var i in arr) {
        if (arr[i][str] === _tmp) {
          _t.push(arr[i]);
        } else {
          _tmp = arr[i][str];
          _arr.push(_t);
          _t = [arr[i]];
        }
      }
      // 将最后的内容推出新数组
      _arr.push(_t);
      return _arr.reverse();
    },
    handleClick(data) {
      let _this = this;

      //已经点过赞了
      _this.$api.userCenter.user.noteBox
        .noteLike(data.id)
        .then((res) => {
          if (res.code == "1") {
            if (data.isLike) {
              data.likeNum++;
            } else {
              data.likeNum--;
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });

      data.isLike = !data.isLike;
    },
    //请求App上传图片
    getImgs() {
      let _this = this;
      if (_this.clientType == "android") {
        window.android.getInfo(101);
      } else {
        window.webkit.messageHandlers.getImgs.postMessage("1");
      }
    },
    setFiles(data) {
      //App回调添加上传文件
      let arr = [];
      if (this.clientType == "android") {
        this.baseData.imgs.push(data.url);
      } else {
        let cc = JSON.parse(data);
        this.baseData.imgs.push(cc.url);
      }
    },
    onLoad() {
      this.initPage();
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.dataList = []; //数据集合
      this.pageNum = 0; //当前页码
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    seeImg(item, img) {
      let newItemArr = [];
      item.forEach((imgItem) => {
        newItemArr.push(imgItem + "?x-oss-process=image/resize,p_50");
      });
      Showswiper(newItemArr, img);
    },
    getJumpUrl(item) {
      let Url = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      let orgId = this.$route.query.orgId;
      Url =
        LocationHref +
        "shareDetail?token=" +
        token +
        "&commonId=" +
        item.id +
        "&commonType=keepRecord&orgId=" +
        orgId;
      if (this.clientType == "android") {
        window.android.getInfo(112, Url, item.id);
      } else {
        //IOS
        console.log(Url);
        window.webkit.messageHandlers.getJumpUrl.postMessage(Url, item.id);
      }
      // }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.keepRecordPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .ul_List {
    background-color: #f9f9f9;
  }
  .list_ul {
    height: 100%;
    padding: 10px 12px 20px;
    overflow-y: scroll;
  }
  .list_li {
    padding-bottom: 12px;
    position: relative;
    .ggCircle {
      display: block;
      width: 8px;
      height: 8px;
      background-color: #21bc9c;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      box-shadow: 0px 1px 6px 0px rgba(33, 188, 156, 1);
      position: absolute;
    }
    .circleBox {
      position: absolute;
      top: 60px;
      left: 30px;
      height: calc(100% - 80px);
      border-left: 1px dotted #21bc9c;

      .circleFirst {
        top: -10px;
        left: 50%;
        margin-left: -5px;
      }
      .circleLast {
        bottom: 0;
        left: 50%;
        margin-left: -5px;
      }
    }
  }
  .itemLi {
    position: relative;
    margin-bottom: 12px;
    .childCircle {
      top: -0;
      left: 26px;
    }
    .list_left {
      width: 65px;
      margin-right: 12px;
      flex-shrink: 0;
      span {
        display: inline-block;
        width: 100%;
        font-size: 16px;
        font-family: "PingFangSC-Regular", " PingFang SC";
        color: #000;
        opacity: 0.6;
        line-height: 22px;
        text-align: center;
      }
    }
    .imgWrap {
      width: 100%;
      flex-wrap: wrap;
      .img {
        width: 33.33%;
        padding-right: 6px;
        padding-bottom: 6px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        img {
          width: 75px;
          height: 75px;
          border-radius: 5px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
        }
      }
    }
    .list_right {
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      -webkit-boeder-radius: 8px;
      -moz-border-radius: 8px;
      padding: 8px 8px 10px 8px;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.07);
      // padding-bottom: 20px;
      .titleWrap {
        position: relative;
        img {
          width: 25px;
          height: 25px;
          border-radius: 50%;
        }
        .title {
          margin-left: 10px;
          display: inline-block;
          color: #000;
          font-size: 15px;
          font-weight: 600;
          opacity: 0.6;
          line-height: 25px;
          font-family: "PingFangSC-Medium", "PingFang SC";
        }
      }
      .textWrap {
        margin: 10px 0 10px 0;
      }
      .peopleAction {
        margin-top: 5px;
        position: relative;

        .smallText {
          font-size: 12px;
          color: #000;
          opacity: 0.6;
        }
        .actionItem {
          position: absolute;
          top: 0;
          right: 10px;
        }
        .criticLike {
          display: inline-block;
          margin-right: 8px;
          span {
            display: block;
          }
          .criticLikeIcon {
            i {
              font-size: 18px;
              color: #000;
              vertical-align: bottom;
            }
            .criticCount {
              display: inline-block;
              font-size: 12px;
              color: #000;
              margin-left: 3px;
            }
          }
          .criticLikeIcon.red {
            i {
              color: #21bc9c;
            }
          }
        }
        .commentNum {
          display: inline-block;
          span {
            display: block;
          }
          .commentIcon {
            i {
              font-size: 16px;
              color: #000;
              vertical-align: bottom;
            }
            .commentCount {
              display: inline-block;
              font-size: 12px;
              color: #000;
              margin-left: 3px;
            }
          }
        }
      }
    }
  }
  .itemLi:last-child {
    margin-bottom: 0;
  }
}
</style>